import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SnackbarNotificationService } from '../../../services/snackbar-notification.service';
import { SnackbarNotificationComponent } from '../snackbar-notification/snackbar-notification.component';

@Component({
    selector: 'lib-snackbar-notifications-container',
    templateUrl: './snackbar-notifications-container.component.html',
    styleUrls: ['./snackbar-notifications-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SnackbarNotificationComponent]
})
export class SnackbarNotificationsContainerComponent {
    readonly snackbar = inject(SnackbarNotificationService);
}
